const userDataDefaults = {
  hasNetpvr: false,
  hasViihdeOnline: false,
  isElisaIdOnly: false,
  isImpersonated: false,
  impersonatorElisaId: '',
  isLoggedIn: false,
  marketingConsent: "UNKNOWN",
  services: [],
  stronglyIdentified: false,
  termsAccepted: false,
  username: ''
};

function user(state = userDataDefaults, action) {
  switch (action.type) {
    case 'CURRENT_USER_DATA':
      if (action.data.username === '') { // user logged out
        return { ...userDataDefaults };
      }

      if (action.data.isImpersonated === undefined) {
        action.data.isImpersonated = !!action.data.impersonatorElisaId;
      }

      return { ...state, ...action.data, isLoggedIn: true };
  }

  return state;
}

export default user;



// WEBPACK FOOTER //
// ./web/js/stores/reducers/user.js